var vasabMapLastSelected = $();
$(function() {

    $('g[id^=\"vm-\"], path[id^=\"vm-\"]').click(function(e) {
        var id = e.target.id;
        if(id === ''){
            id = $(e.target).closest("g[id^=\"vm-\"]").attr('id');
        }

        vasabMapLastSelected.removeClass('vasab-map__map--highlight');
        $('.vasab-map__info-box').css('display','none');
        $('#info-'+id).find('.vasab-map__close').removeClass('is-active');

        var styles = {
            display : "block",
            top: e.pageY - $('#info-'+id).height() < 0 ? 3 : e.pageY - $('#info-'+id).height(),
            left: e.pageX
        };

        $('#info-'+id).css(styles);

        $(this).addClass('vasab-map__map--highlight');

        // Wait a bit, because animation works only after display:none is removed
        setTimeout(function() {
            $('#info-'+id).find('.vasab-map__close').addClass('is-active');
        }, 12);

        vasabMapLastSelected = $(this);
    });

    $(document).click(function(event) {
        if(!$(event.target).closest('g[id^="vm-"] path, path[id^="vm-"], .vasab-map__info-box').length) {
            $('.vasab-map__info-box').css('display','none');
            vasabMapLastSelected.removeClass('vasab-map__map--highlight');
        }
    });

    $(document).on('click', '.vasab-map__close', function (e) {
        e.preventDefault();
        $(this).removeClass('is-active');
        $(this).closest('.vasab-map__info-box').css('display', 'none');
        vasabMapLastSelected.removeClass('vasab-map__map--highlight');
    });

    $(window).on('resize', function(e) {
        $('.vasab-map__info-box').css('display','none');
        vasabMapLastSelected.removeClass('vasab-map__map--highlight');
    });

});